<template>
    <div>

        <b-breadcrumb class="text-capitalize">
            <b-breadcrumb-item :to="{ name: '/' }" active><font-awesome-icon icon="caret-right" class="mr-1" />User Profile</b-breadcrumb-item>
        </b-breadcrumb>

        <b-overlay :show="isLoading" rounded="sm">

            <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

            <div v-if="isLoadingError == false"  class="container-fluid ml-2">
                <div class="row p-2">
                    <div class="col-8">
                        <b-card title="User Profile" sub-title="Your user details for accessing VO2 Master Cloud">

                            <p>
                                <small>Account#: {{currentValue.userAccountId}}</small><br>
                                <small>Last login: <span>{{ currentValue.lastLoginAt | moment("dddd MMMM Do, YYYY, h:mm:ss a")}}</span></small>
                            </p>

                            <b-button size="sm" class="my-2 px-2" variant="primary" v-on:click.stop="onEdit()">
                                <font-awesome-icon icon="edit" class="mx-2" />
                                <span>Edit Your Profile</span>
                            </b-button>
                            <b-list-group flush class="data-item">
                                <b-list-group-item>
                                    <div class="d-flex justify-content-between">
                                        <span><b>Email :</b></span>
                                        <span>{{currentValue.emailAddress}}</span>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="d-flex justify-content-between">
                                        <div><b>First Name :</b></div>
                                        <div>{{currentValue.firstName}}</div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="d-flex justify-content-between">
                                        <div><b>Last Name :</b></div>
                                        <div>{{currentValue.lastName}}</div>
                                    </div>
                                </b-list-group-item>
                              <b-list-group-item>
                                <div class="d-flex justify-content-between" >
                                  <div><b>Country :</b></div>
                                  <div>{{currentValue.countryCode}}</div>
                                </div>
                              </b-list-group-item>
                                <b-list-group-item>
                                    <div class="d-flex justify-content-between" >
                                        <div><b>Company :</b></div>
                                        <div>{{currentValue.companyName}}</div>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item>
                                    <div class="d-flex justify-content-between">
                                        <div><b>Phone :</b></div>
                                        <div>{{currentValue.phoneNumber}}</div>
                                    </div>
                                </b-list-group-item>
                            </b-list-group>

                        </b-card>
                    </div>
                </div>

            </div>

        </b-overlay>

        <UserDetailsModal />

    </div>
</template>

<script>

    import { mapGetters } from 'vuex'
    import UserDetailsModal from './UserDetailsModal'
    import ErrorView from '../ErrorView'

    export default {
        name: "UserDetailsPage",
        components: {
            UserDetailsModal,
            ErrorView
        },
        computed: {
            ...mapGetters({

                userAccount: 'userAccount/current',
                userAccountName: 'userAccount/currentName',
                userAccountLoading: 'userAccount/currentLoading',
                userAccountLoadingError: 'userAccount/currentLoadingError',
                userAccountLoadingErrorValue: 'userAccount/currentLoadingErrorValue',
            }),

            isLoading: function() {
                return this.userAccountLoading;
            },
            isLoadingError: function() {
                return this.userAccountLoadingError || (!this.isLoading && !this.userAccount);
            },
            loadingErrorValue: function() {
                return this.userAccountLoadingErrorValue;
            },


            currentValue: function() {

                let value = {

                    userAccountId: '',

                    firstName: '',
                    lastName: '',

                    emailAddress: '',
                    emailVerified: '',

                    companyName: '',
                    phoneNumber: '',

                    countryCode: '',

                    lastLoginAt: '',
                };

                if(this.userAccount) {

                    value.userAccountId = this.userAccount.userAccountId;

                    value.firstName = this.userAccount.firstName;
                    value.lastName = this.userAccount.lastName;

                    value.emailAddress = this.userAccount.emailAddress;
                    value.emailVerified = this.userAccount.emailVerified;

                    value.companyName = this.userAccount.companyName;
                    value.phoneNumber = this.userAccount.phoneNumber;

                    value.countryCode = this.userAccount.countryCode;

                    value.lastLoginAt = this.userAccount.lastLoginAt;
                }

                return value;
            }
        },
        methods: {

            onEdit() {

                this.$bvModal.show('edit-user-modal')
            },
        }
    }
</script>

<style scoped>

</style>